import React, {Component} from 'react';
import Event from './fragments/Event';
import About from './fragments/About';
import {Pricing} from './fragments/Prices';
import {Featured} from "./fragments/Featured";

import './Home.css'
import {Page, PagePanel} from "../../components/helpers/PagePanel";
import {FeaturedSponsors} from "../../components/sponsors/SponsorsPanel";


class Home extends Component {

    render() {
        return (
            <Page className="Home">
                <Event/>
                <About/>
                <Pricing/>
                <Featured/>
                <PagePanel className="transparent">
                    <FeaturedSponsors/>
                </PagePanel>
            </Page>
        );
    }

}

export default Home;




// WEBPACK FOOTER //
// ./src/pages/home/Home.js